import React from 'react';
import { fetchMyHiredJobs } from '../../../services/api';
import useWorkerJobStatus from '../../../features/jobs/hooks/useWorkerJobStatus';
import WorkerJobCard from '../components/WorkerJobCard';
import CardIcon from '../../../shared/components/icons/CardIcon';

function HiredJobs() {
  const { jobs, loading, error } = useWorkerJobStatus(fetchMyHiredJobs);

  return (
    <div className="space-y-6">
      <div className="rounded-3xl bg-white p-6 sm:p-8 shadow-sm"><h1 className="flex items-center gap-3 text-2xl sm:text-3xl font-bold tracking-tight text-navy"><CardIcon name="briefcase" className="h-7 w-7" />Hired Jobs</h1><p className="mt-2 text-sm text-slate-600">View the jobs where an employer selected you.</p></div>
      {loading && <div className="rounded-3xl bg-white p-8 text-center text-slate-600 shadow-sm">Loading hired jobs...</div>}
      {error && <div className="rounded-3xl bg-rose-50 p-8 text-center text-rose-700 shadow-sm">Error: {error}</div>}
      {!loading && !error && jobs.length === 0 && <div className="rounded-3xl bg-white p-8 text-center text-slate-500 shadow-sm">No hired jobs found.</div>}
      {!loading && !error && <div className="space-y-5">{jobs.map((item) => <WorkerJobCard key={item.applicationId} item={item} />)}</div>}
    </div>
  );
}

export default HiredJobs;
